module.exports = __webpack_public_path__ + "templates.dialog-delete-credit-card-0e4631f1.html";